import { render, staticRenderFns } from "./shiChiGuanOrderAll.vue?vue&type=template&id=2ff349b7&scoped=true&"
import script from "./shiChiGuanOrderAll.vue?vue&type=script&lang=js&"
export * from "./shiChiGuanOrderAll.vue?vue&type=script&lang=js&"
import style0 from "./shiChiGuanOrderAll.vue?vue&type=style&index=0&id=2ff349b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff349b7",
  null
  
)

export default component.exports